import { Button, ButtonProps } from "antd"

export default function ButtonPrimary(props: ButtonProps) {
  return (
    <Button
      {...props}
      className={`rounded-lg text-13 h-10 border-none bg-primary text-white focus:bg-primary focus:text-white hover:!bg-primary hover:!text-white disabled:!bg-primary disabled:opacity-50 disabled:text-white ${props.className}`}
    />
  )
}
